<template>
  <el-dialog
    class="epc-orderpay-modal"
    width="90%"
    title="EPC订单标记付款"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <form v-loading="loading" class="respone-form">
      <div class="field">
        <el-input type="text" v-model="context.orderSn" placeholder="订单编号"></el-input>
      </div>
      <div class="field">
        <el-select v-model="context.payType" placeholder="支付方式">
          <el-option label="卖家标记" :value="4"></el-option>
          <el-option label="支付宝" :value="1"></el-option>
          <el-option label="微信" :value="2"></el-option>
        </el-select>
      </div>
      <div class="field">
        <el-select v-model="context.paySn" placeholder="收款方" allow-create filterable>
          <el-option label="网银对公" value="网银对公"></el-option>
          <el-option label="汇付TP" value="汇付TP"></el-option>
          <el-option label="黄任一" value="黄任一"></el-option>
        </el-select>
      </div>
      <div class="actions">
        <el-button type="primary" size="small" @click="doSubmit">确定</el-button>
        <el-button type="default" size="small" @click="close(false)">取消</el-button>
      </div>
    </form>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import { EpcOrderPay } from '../services'
import _ from 'lodash'
export default {
  name: 'PassportUnlockModal',
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      context: {
        orderSn: '',
        payType: 4,
        paySn: ''
      }
    }
  },
  created () {
    this.debounceRequest = _.debounce(() => {
      EpcOrderPay(this.context).then((resp) => {
        this.$message.success(JSON.stringify(resp.data))
        this.close(true)
      })
    }, 5000, {
      leading: true,
      trailing: false
    })
  },
  methods: {
    init () {
      return this.open()
    },
    checkModel () {
      return new Promise((resolve, reject) => {
        const { orderSn, payType, paySn } = this.context
        if (!orderSn) reject(new Error('请输入订单编号'))
        if (!payType) reject(new Error('请选择支付方式'))
        if (payType === 4 && !paySn) reject(new Error('请选择收款方'))
        resolve(true)
      })
    },
    doSubmit () {
      this.checkModel().then(() => {
        this.debounceRequest()
      }).catch((err) => {
        this.$message.error(err.message)
      })
    }
  }
}
</script>
<style lang="stylus">
.epc-orderpay-modal
  .el-dialog
    max-width 800px
    .el-dialog__body
      padding-top 10px
      .field
        .el-select
          width 100%
        +.field
          margin-top 12px
    .actions
      margin-top 12px
      text-align center
</style>
